import React from 'react';
import { Modal, Input, Form, Icon, DatePicker, Tabs, Table, Empty } from 'antd';
import moment from 'moment';
import './styles.css';
import auth from '../../../common/utility/auth';

import { FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import {
    LOGISTICA_PRODUCTOS_CON_LOTE,
} from '../../../common/types/parametroType';
const InputGroup = Input.Group;
const { TabPane } = Tabs;

class FormModalVer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };


    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('arrDetalle', { initialValue: [] });

        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        const mostrarVencimiento = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
        const mostrarLoteProducto = mostrarVencimiento;

        return (
            <Modal
                title="Ver Transferencia"
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Aceptar"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    {getFieldDecorator('idMovimientoIngreso', { initialValue: this.props.formValues.idMovimientoIngreso })(
                        <input type="hidden" />
                    )}
                    {getFieldDecorator('idMovimientoSalida', { initialValue: this.props.formValues.idMovimientoSalida })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                disabled
                                            />
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3)
                                        })(
                                            <Input
                                                disabled
                                            />
                                        )}
                                    </Form.Item> */}

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Nro. Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('nombreMoneda', {
                                    initialValue: this.props.formValues.nombreMoneda
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>



                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.nombreEstablecimientoOrigen
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacenOrigen', {
                                    initialValue: this.props.formValues.nombreAlmacenOrigen
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Número Vale Origen">
                                {getFieldDecorator('numeroValeOrigen', {
                                    initialValue: this.props.formValues.numeroValeOrigen
                                })(
                                    <Input
                                        autoComplete="off"
                                        disabled={true}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>


                    <div className="row">

                        <div className="col-md-3 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento2', {
                                    initialValue: this.props.formValues.nombreEstablecimientoDestino
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacenDestino', {
                                    initialValue: this.props.formValues.nombreAlmacenDestino
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Número Vale Destino">
                                {getFieldDecorator('numeroValeDestino', {
                                    initialValue: this.props.formValues.numeroValeDestino
                                })(
                                    <Input
                                        autoComplete="off"
                                        disabled={true}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>


                    <div className="row">

                        <div className="col-md-4 form-group">
                            <Form.Item label="Encargado Recepción">
                                {getFieldDecorator('recepcion', {
                                    initialValue: this.props.formValues.recepcion
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('proyecto', {
                                    initialValue: this.props.formValues.proyecto
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>


                    </div>


                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input readOnly={true} />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.idProducto}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='No se han agregado productos'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Código',
                                                dataIndex: 'codigo',
                                                key: 'codigo',
                                                align: 'center',
                                                width: 80,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Nombre',
                                                dataIndex: 'nombre',
                                                key: 'nombre',
                                                width: 300,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Unidad Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                                width: 120,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Cantidad',
                                                dataIndex: 'cantidad',
                                                key: 'cantidad',
                                                align: 'center',
                                                width: 90
                                            },

                                            (mostrarVencimiento ? {
                                                title: 'Fecha Produccion',
                                                dataIndex: 'fechaProduccion',
                                                key: 'fechaProduccion',
                                                width: 120,
                                                className: 'hide'
                                            } : {}),
                                            (mostrarVencimiento ? {
                                                title: 'Fecha Vencimiento',
                                                dataIndex: 'fechaVencimiento',
                                                key: 'fechaVencimiento',
                                                width: 120,
                                                className: 'hide'
                                            } : {})
                                            ,
                                            (mostrarVencimiento ? {
                                                title: 'Numero Registro Sanitario',
                                                dataIndex: 'numeroRegistroSanitario',
                                                key: 'numeroRegistroSanitario',
                                                width: 120,
                                                className: 'hide'
                                            } : {}),
                                                   (mostrarLoteProducto ? {
                                                  title: 'Lote',
                                                dataIndex: 'numeroLote',
                                                key: 'numeroLote',
                                                width: 120,
                                                className: 'hide'
                                            } : {}),

                                          



                                        ]}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <Table
                                        className={'table-referencia'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        rowKey={record => record.identifier}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='Pulse el botón "+ Agregar".'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Tipo Comprobante',
                                                dataIndex: 'nombreTipoComprobante',
                                                key: 'nombreTipoComprobante',
                                                align: 'center',
                                                width: 350,
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Serie',
                                                dataIndex: 'serie',
                                                key: 'serie',
                                                width: 100,
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Documento',
                                                dataIndex: 'documento',
                                                key: 'documento',
                                                width: 120,
                                                ellipsis: true
                                            }
                                        ]}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    {/*      <div className="row" hidden>
                        <div className={"col-md-6"}>

                        </div>
                        <div className="col-md-3 form-group">

                        </div>
                        <div className="col-md-3 pt-10">

                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Sub Total</label>
                                    <div>{this.props.formValues.sumaSubTotal.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>IGV</label>
                                    <div>{this.props.formValues.sumaIgv.toFixed(2)}</div>
                                </div>
                            </div>
                            <div className="col text-right mb-5">
                                <div className="total-inline">
                                    <label>Total</label>
                                    <div>{this.props.formValues.sumaTotal.toFixed(2)}</div>
                                </div>
                            </div>

                        </div>
                    </div> */}

                </Form>
            </Modal>
        )
    }
}

export default Form.create()(FormModalVer)